// extracted by mini-css-extract-plugin
export default {"root":"V1gkuu"};